export const nameSpace = '@@/housing';
